












import { IField } from './constants';

export default {
  props: {
    value: [String, Number, Object, Array, Date, Boolean],
    params: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    FieldBase: () => import('./Base.vue'),
  },
  methods: {
    update($event: any, key: any) {
      this.value[key] = $event;
      this.$emit('change', this.value);
    },
  },
} as IField;
